import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Switch, Redirect, useLocation } from "react-router-dom";
import { I18nextProvider } from 'react-i18next';

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";

import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";
import Protect from "views/protect";
import Login from "views/auth/Login";
import Landing from "views/Landing.js";
import Profile from "views/Profile.js";
import About from "views/About";
import Services from "views/Services";
import Demande from "views/Demandes";
import Contact from "views/Contact";
import Mademande1 from "views/mademande";
import Landing1 from "views/con/Landing";
import Services1 from "views/con/Services";
import Contact1 from "views/con/Contact";
import About1 from "views/con/About";
import Projects from "views/footer";
import Me from "layouts/me";

import Navbar from "components/Navbars/IndexNavbar";
import Footer from "components/Footers/Footer";
import DelayedRoute from "layouts/DelayedRoute";
import TemoignagesPage from "views/témoignagesPage";
import DemandeResetMdp from "views/demandeResetMdp";
import ResetMdp from "views/resetMdp";
import Portefeuille from "Banque/Client/portefeuille";
import Virement from "Banque/Client/virement";
import CarteVirtuelle from "Banque/Client/carte";
import MonCompte from "Banque/Client/compteClient";
import EnvoiEmail from "views/admin/EnvoiEmail";

// Pages légales
import MentionsLegales from "views/legal/MentionsLegales";
import Confidentialite from "views/legal/Confidentialite";
import CGU from "views/legal/CGU";
import Cookies from "views/legal/Cookies";

// Routes avec Navbar ET Footer
const routesWithNavbarAndFooter = [
  '/',
  '/about',
  '/services',
  '/contact',
  '/demande',
  '/project',
  '/testimonials',
  '/forgot',
  '/banque/portefeuille',
  '/banque/virement',
  '/banque/carte',
  '/banque/compte',
  '/faq'
];

// Routes avec Navbar SEULEMENT (pas de Footer)
const routesWithNavbarOnly = [
  '/login',
  '/mentions-legales',
  '/cgu',
  '/confidentialite',
  '/cookies'
];

const App = () => {
  const location = useLocation();
  
  // Fonction pour vérifier si le path correspond
  const matchesRoute = (routes) => {
    return routes.some(route => {
      if (route === '/') {
        return location.pathname === '/';
      }
      return location.pathname.startsWith(route);
    }) || location.pathname.match(/^\/reset-password\/[^/]+\/[^/]+$/);
  };

  const showNavbar = matchesRoute([...routesWithNavbarAndFooter, ...routesWithNavbarOnly]);
  const showFooter = matchesRoute(routesWithNavbarAndFooter);

  return (
    <>
      {showNavbar && <Navbar />}
      <Switch>
        <DelayedRoute path="/admin" component={Admin} isPrivate isAdminRoute />
        <DelayedRoute path="/auth" component={Auth} />
        <DelayedRoute path="/faq" component={Protect} isReverse />
        <DelayedRoute path="/me" component={Me} isPrivate isClientPage />
        <DelayedRoute path="/" exact component={Landing} isReverse />
        <DelayedRoute path="/about" exact component={About} isReverse />
        <DelayedRoute path="/services" exact component={Services} isReverse />
        <DelayedRoute path="/contact" exact component={Contact} isReverse />
        <DelayedRoute path="/demande" exact component={Demande} isReverse />
        <DelayedRoute path="/login" exact component={Login} isReverse />
        <DelayedRoute path="/project" exact component={Projects} isReverse />
        <DelayedRoute path="/testimonials" exact component={TemoignagesPage} isReverse />
        <DelayedRoute path="/forgot" exact component={DemandeResetMdp} isReverse />
        <DelayedRoute path="/reset-password/:token/:email" exact component={ResetMdp} isReverse />
        
        <DelayedRoute path="/banque/portefeuille" exact component={Portefeuille} isReverse />
        <DelayedRoute path="/banque/virement" exact component={Virement} isReverse />
        <DelayedRoute path="/banque/carte" exact component={CarteVirtuelle} isReverse />
        <DelayedRoute path="/banque/compte" exact component={MonCompte} isReverse />

        <DelayedRoute path="/mentions-legales" exact component={MentionsLegales} isReverse />
        <DelayedRoute path="/confidentialite" exact component={Confidentialite} isReverse />
        <DelayedRoute path="/cgu" exact component={CGU} isReverse />
        <DelayedRoute path="/cookies" exact component={Cookies} isReverse />

        <DelayedRoute path="/profile" exact component={Profile} isPrivate isClientPage />
        <DelayedRoute path="/mademande" exact component={Mademande1} isPrivate isClientPage />
        <Redirect from="*" to="/" />
      </Switch>
      {showFooter && <Footer />}
    </>
  );
};

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);